export const STEPUP_AUTHENTICATION_REMINDER_KEY = 'stepup_auth_reminder';
export const STEPUP_AUTHENTICATION_EXPIRY_NOTIFICATION_KEY = 'stepup_auth_expiry_notification';
export const REMINDER_BEFORE_MIN = 5;
export const MIN_ALLOWED_TIME = 10;
export const MAX_ALLOWED_TIME = 60;
export const DEFAULT_TIME = 60;
